import { Moment } from "moment";

export const formatRequestDate = (date: Moment) => date.format("YYYY-MM-DD");

export const formatDisplayDate = (date: Moment) => {
  return date.format("MM/DD/YYYY");
};
